import { createSlice } from '@reduxjs/toolkit'
import { getPurchases, savePurchase, createPurchase, deletePurchase } from './purchaseActions'

const initialState = {
  purchases: [],
  loading: false,
  error: false,
  loadingError: false,
  savingError: false,
  saving: false,
  saved: false,
  savedPurchase: {},
  deleting: false,
  deleted: false,
  deletingError: false,
}

function isRejectedAction(action) {
  return action.type.endsWith('rejected')
}

const purchaseSlice = createSlice({
  name: 'purchases',
  initialState,
  reducers: {
    clear: (state) => {
      state.saved = false
      state.savingError = false
      state.loadingError = false
      state.savedPurchase = {}
      state.deleting = false
      state.deleted = false
      state.deletingError = false
    },
  },

  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(getPurchases.fulfilled, (state, { payload }) => {
        state.loading = false
        state.purchases = payload
      })
      .addCase(getPurchases.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(savePurchase.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(savePurchase.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.purchases[state.purchases.findIndex((p) => p.id === payload.id)] = payload
        state.savedPurchase = payload
        state.saved = true
        state.saving = false
      })
      .addCase(savePurchase.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(createPurchase.pending, (state) => {
        state.saving = true
        state.savingError = null
        state.saved = false
      })
      .addCase(createPurchase.fulfilled, (state, { payload }) => {
        state.savingError = null
        state.savedPurchase = payload
        state.saved = true
        state.saving = false
      })
      .addCase(createPurchase.rejected, (state, { payload }) => {
        state.saving = false
        state.savingError = payload
        state.saved = false
      })
      .addCase(deletePurchase.pending, (state) => {
        state.deleting = true
        state.deletingError = null
        state.deleted = false
      })
      .addCase(deletePurchase.fulfilled, (state) => {
        state.deletingError = null
        state.deleted = true
        state.deleting = false
      })
      .addCase(deletePurchase.rejected, (state, { payload }) => {
        state.deleting = false
        state.deletingError = payload
        state.deleted = false
      })
      .addMatcher(
        isRejectedAction,
        // `action` will be inferred as a RejectedAction due to isRejectedAction being defined as a type guard
        (state, { payload }) => {
          state.loading = false
          state.error = payload
        },
      )
  },
})
export const { clear } = purchaseSlice.actions
export default purchaseSlice.reducer
